import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RefObject } from 'react'

import { Card, Column, Group } from '../components/Kanban/interfaces/kanban'

export interface DropInstance {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  element: RefObject<any>
  data: Column
}

export interface DragInstance {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  element: RefObject<any>
  data: Group | Card
}

export type DirectionType = 'before' | 'after'

interface DragDropState {
  drag: DragInstance | null
  drop: DropInstance | null
  direction: DirectionType
  isDrop: boolean
}

const initialState: DragDropState = {
  drag: null,
  drop: null,
  direction: 'before',
  isDrop: false,
}

const dragDropSlice = createSlice({
  name: 'dragDrop',
  initialState,
  reducers: {
    setDrag(state, action: PayloadAction<{ value: DragInstance | null }>) {
      state.drag = action.payload.value
    },
    clearDrag(state) {
      state.drag = null
    },
    setDrop(state, action: PayloadAction<{ value: DropInstance | null }>) {
      state.drop = action.payload.value
    },
    clearDrop(state) {
      state.drop = null
    },
    setDirection(state, action: PayloadAction<{ value: DirectionType }>) {
      state.direction = action.payload.value
    },
    setIsDrop(state, action: PayloadAction<{ value: boolean }>) {
      state.isDrop = action.payload.value
    },
  },
})

export const {
  setDrag,
  clearDrag,
  setDrop,
  clearDrop,
  setDirection,
  setIsDrop,
} = dragDropSlice.actions

const DragDropReducer = dragDropSlice.reducer

export default DragDropReducer
